import { MenuItem, Pagination } from "@mui/material";
import TextInput from "../form/TextInput";

function CommonPaginationSection({ callback, perPage = 10, total = 10, page }) {
  const count = Math.ceil(Math.max(total, perPage) / perPage);

  const handlePageChange = (pg) => {
    callback?.(pg, perPage);
  };

  const pages = [10, 20, 30, 40];

  return (
    <div className="flex justify-end mt-10 gap-4">
      <Pagination
        count={count}
        onChange={(e, pg) => handlePageChange(pg)}
        page={page || 1}
        variant="outlined"
        shape="rounded"
      />
      <div className="inline-block">
        <TextInput
          select
          label=""
          className="!h-6 !text-xs"
          value={perPage}
          onChange={(ev) => {
            callback?.(1, ev.target.value || 10);
          }}
          sx={{
            "& .MuiInputBase-root": {
              height: "32px",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderRadius: "4px",
            },
            "& .MuiInputLabel-root": {
              lineHeight: "32px",
            },
          }}
        >
          {pages?.map((val, i) => (
            <MenuItem key={i} value={val}>
              {val} / page
            </MenuItem>
          ))}
        </TextInput>
      </div>
    </div>
  );
}

export default CommonPaginationSection;
